import React, { useEffect, useState } from 'react';
import { getMyHistory } from '../services/assujettiService';

interface HistoryEvent {
  event_type: string;
  event_date: string;
  establishment_name: string;
  description: string;
  user_name: string;
}

const typeBadge: Record<string, string> = {
  FPT: 'bg-blue-100 text-blue-700',
  Paiement: 'bg-green-100 text-green-700',
  Licence: 'bg-purple-100 text-purple-700',
  Controle: 'bg-orange-100 text-orange-700',
};

export default function V4HistoryPage() {
  const [events, setEvents] = useState<HistoryEvent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getMyHistory()
      .then((res) => setEvents(res.data ?? []))
      .catch(() => setError('Impossible de charger l\'historique.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Historique</h1>
      <p className="text-gray-500 text-sm mb-6">Journal des actions FPT et licences.</p>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 text-sm text-red-800">{error}</div>
      )}

      {loading ? (
        <p className="text-gray-500 text-sm">Chargement...</p>
      ) : events.length === 0 ? (
        <p className="text-gray-500 text-sm">Aucun evenement pour le moment.</p>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {['Date', 'Type', 'Etablissement', 'Evenement', 'Utilisateur'].map(h => (
                  <th key={h} className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {events.map((r, i) => (
                <tr key={i} className="hover:bg-gray-50">
                  <td className="px-5 py-4 text-sm text-gray-600">{new Date(r.event_date).toLocaleDateString('fr-FR')}</td>
                  <td className="px-5 py-4">
                    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${typeBadge[r.event_type] ?? 'bg-gray-100 text-gray-700'}`}>{r.event_type}</span>
                  </td>
                  <td className="px-5 py-4 text-sm font-medium">{r.establishment_name}</td>
                  <td className="px-5 py-4 text-sm">{r.description}</td>
                  <td className="px-5 py-4 text-sm text-gray-500">{r.user_name || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
